import React from 'react';
import { Messages, Control, API, Code, Name, Title, Actions, Form, Hooks, Files, Toast, Button, useListContext, useCallback, useEffect, useState, Utility } from 'helpers/ListImports';
import { Inquiry } from 'models/InquiryModel';


const InquiryList: React.FC = () => {
  const width = { date: 12, name: 16, phone: 15, email: 15, interest: 12, response:12, followup: 12 }
  const [formId, formName] = [Code.Form.Id.INQUIRY, Code.Form.Name.INQUIRY];
  const { loading, setLoading, error, setError, search, setSearch, pno, setPno, pageRows, setPageRow, activeId, setActiveId, selected, setSelected, confirm, setConfirm, message, setMessage,  showMenu, setShowMenu, selectedItems, setSelectedItems, selectAllChecked, setSelectAllChecked, activeOptions, setActiveOptions, rowOptions, setRowOptions, menuPosition, setMenuPosition, iframeRef, filterRef, contextMenuRef  } = useListContext();
  const [inquiryData, setInquiryData] = useState<Inquiry[]>([]); 
  const [selectedInquiry, setselectedInquiry] = useState<Inquiry | null>(null);
  
  const triggers = [pno, pageRows, search, activeId];
  const Privilege = Hooks.Privilege.List(formId);
  const locationId = Utility.Storage.LocationId();

  Hooks.Privilege.HasView(Privilege);
  
  Form.Click.Outside([contextMenuRef, filterRef],[() => setShowMenu(false),() => {}],true);
  Form.Select.OnChange(selectedItems, setSelected);

  useEffect(() => {
    Files.Json.Http(Code.File.ACTIVE, Code.Option.Common.NOTHING, setActiveOptions, setError);
    Files.Json.Http(Code.File.ROW, Code.Option.Common.NOTHING, setRowOptions, setError);
  }, []);

  useEffect(() => {
    callListData(); 
  }, triggers);
 
  const callListData = useCallback(async () => {
    const url = API.Build.ListApiEndpoint(formName, pno, pageRows, Name.Inquiry.Id, Code.Option.Sort.DESC, activeId, search, {
      fields: Utility.Join.Fields([
        Name.Inquiry.Date, 
        Name.Inquiry.Name, 
        Name.Inquiry.Phone, 
        Name.Inquiry.Email, 
        Name.Inquiry.InterestName, 
        Name.Inquiry.ResponseName, 
        Name.Inquiry.FollowupDate
      ]),
      ...(!Privilege.ALLLOC && { location_id: locationId }),
    });
     
    await API.Data.List<Inquiry>(url, setInquiryData, setError, setLoading); 
  }, triggers);

  return (
    <Control.List.Frame>
      <Control.List.Panel>
        <Control.List.Tools>
          <Control.Tool.Left>
            <Button.Create title={formName} onClick={() => Form.Show.Popup(iframeRef, formName)} Privilege={Privilege} />
            {selected && ( <Button.Delete onClick={()=>Toast.Delete.MultipleRecords(activeId, selectedItems, setConfirm)} activeId={activeId} Privilege={Privilege} /> )}
          </Control.Tool.Left>
          <Control.Tool.Right>
            <Control.SearchBar onSearch={setSearch} onFilterToggle={() => Form.Show.Filter(filterRef)}  onGoClick={() => callListData()} />
            <Control.List.Filter filterRef={filterRef}>
              <Control.Dropdown title={Title.Status} value={activeId} options={activeOptions} onChange={setActiveId} />
              <Control.Dropdown title={Title.Rows} value={pageRows} options={rowOptions} onChange={setPageRow} />
            </Control.List.Filter>
            <Messages.Confirm Messages={confirm} onConfirm={() => API.Data.MultiDelete(formName, activeId, callListData, selectedItems, setConfirm, setMessage, setSelected, setSelectedItems, setError) } onRefuse={() => setSelectedItems([])} />
          </Control.Tool.Right>
        </Control.List.Tools>
        <Control.List.Data>
          <Control.List.Box>
            <Control.List.Title>
              <Control.SelectAll selectAllChecked={selectAllChecked} onSelectAll={(e) => Form.Select.All(e, setSelectedItems, inquiryData, setSelectAllChecked,formName)} extra={1} />
              <Control.Grid.Items values={[
                [Title.Date, width.date],
                [Title.ClientName, width.name],
                [Title.Phone, width.phone], 
                [Title.Email, width.email], 
                ["Interested", width.interest], 
                ["Response", width.response], 
                ["Follow up", width.followup], 
              ]} last={1} upper={true} />
            </Control.List.Title>
            {!loading && !error && Array.isArray(inquiryData) && (
              <Control.Grid.Row>
                {inquiryData.map((inquiryData) => { return (
                <Control.Grid.Data<Inquiry> key={inquiryData.inquiry_id} itemKey={inquiryData.inquiry_key} data={inquiryData} setMenuPosition={setMenuPosition} setSelectedData={setselectedInquiry} setShowMenu={setShowMenu} >
                  <Control.Grid.Check keyId={inquiryData.inquiry_key} selectedItems={selectedItems} toggleSelection={Form.Select.Toggle} setSelectedItems={setSelectedItems} />
                  <Control.Grid.Modify path={Utility.Join.Edit(Privilege,formName, inquiryData.inquiry_key)} iframeRef={iframeRef} Privilege={Privilege} />
                  <Control.Grid.Items values={[
                    [Utility.Format.DateOnly(inquiryData.inquiry_date), width.date],
                    [inquiryData.inquiry_name, width.name],
                    [inquiryData.inquiry_phone, width.phone],
                    [inquiryData.inquiry_email, width.email],
                    [inquiryData.interest_name, width.interest],
                    [inquiryData.response_name, width.response],
                    [Utility.Format.DateOnly(inquiryData.inquiry_followup_date), width.followup],
                  ]} />
                  <Control.Grid.Actions>
                    <Control.Action.All formName={formName} activeId={activeId} keyId={inquiryData.inquiry_key} iframeRef={iframeRef} setSelectedItems={setSelectedItems} setConfirm={setConfirm} Privilege={Privilege}><></></Control.Action.All>
                  </Control.Grid.Actions>
                </Control.Grid.Data>)})}
            </Control.Grid.Row>)}
          </Control.List.Box>
        </Control.List.Data>
        <Control.List.Info>
          <Control.RecordInfo pageNo={pno} pageRows={pageRows} loading={loading} error={error} dataLength={inquiryData.length} />
          <Control.Pagination pageNo={pno} onChange={(page) => setPno(page)} />
        </Control.List.Info>
      </Control.List.Panel>
      {showMenu && (<div ref={contextMenuRef}><Control.ListContextMenu showMenu={showMenu} formName={formName} onCreate={() => Form.Show.Popup(iframeRef, formName)} onModify={()=>Form.Show.Popup(iframeRef, Utility.Join.Edit(Privilege, formName, selectedInquiry?.inquiry_key))} onDelete={() => Toast.Delete.SingleRecord(activeId, selectedInquiry?.inquiry_key, setSelectedItems, setConfirm)} onClose={() => Form.Parent.TabClose()} setShowMenu={setShowMenu} Privilege={Privilege} pos={menuPosition} /></div>)}
      <Control.FormPopup iframeRef={iframeRef} onRefresh={callListData} />
      <Actions.List />
    </Control.List.Frame>
  );
};

export default InquiryList;